import React from 'react';
import clsx from 'clsx';
import MuiToolbar from '@material-ui/core/Toolbar';
import { TOOLBAR } from 'ctsutheme/core';

const Toolbar = ({
  narrow, topnavigation, ...props
}) => (
  <MuiToolbar
    className={clsx(TOOLBAR.root, narrow && TOOLBAR.narrow, topnavigation && TOOLBAR.topnavigation)}
    {...props}
  />
);

export default Toolbar;
